/* eslint-disable import/order */
/* eslint-disable jest/require-hook */
import {
  // lgpResultsContainerWidget,
  lgpResultsWidget,
  matchChangeLmpWidget,
  matchCommentsWidget,
  matchHeroSlimWidget,
  matchHeroWidget,
  matchLineupsFieldsWidget,
  matchLineupsWidget,
  matchPredictedLineupsWidget,
  matchStatisticsWidget,
  playerStatisticsWidget,
  driverStatisticsWidget,
} from '@sky-it-livedata/livedata-live-match-pages-widgets';

/* Import Dynamic Components */
// import DynamicLgpResultsContainer from './components/lgp-results-container/dynamic-lgp-results-container';
import DynamicLgpResults from './components/lgp-results/dynamic-lgp-results';
import DynamicMatchChangeLmp from './components/match-change-lmp/dynamic-match-change-lmp';
import DynamicMatchComments from './components/match-comments/dynamic-match-comments';
import DynamicMatchHeroSlim from './components/match-hero-slim/dynamic-match-hero-slim';
import DynamicMatchHero from './components/match-hero/dynamic-match-hero';
import DynamicMatchLineups from './components/match-lineups/dynamic-match-lineups';
import DynamicMatchPredictedLineups from './components/match-predicted-lineups/dynamic-match-predicted-lineups';
import DynamicMatchStartupFormations from './components/match-startup-formations/dynamic-match-startup-formations';
import DynamicMatchStatistics from './components/match-statistics/dynamic-match-statistics';
import DynamicPlayerStatistics from './components/player-statistics/dynamic-player-statistics';
import DynamicdriverStatistics from './components/driver-statistics/dynamic-driver-statistics';
import ageCalc from './utils/age-calc';
import { trackPageViews } from './utils/analytics-track';
import { handleLgpTabs } from './utils/handle-lgp-tabs';
import { hydrateTabsMenu } from './utils/hydrate-tabs-menu';
import manageImagePlaceholders from './utils/placeholder-images';
import resumeAthletePages from './utils/resume-athlete-pages';
import { heroSlimSticky } from './utils/sticky-hero';
import { activeTabScrollIntoView, clickFromHash } from './utils/tabs-utils';
import { defineWebComponents } from './utils/web-components-utils';

const webComponentsMap = new Map();
webComponentsMap.set(matchChangeLmpWidget.tag, DynamicMatchChangeLmp);
webComponentsMap.set(matchCommentsWidget.tag, DynamicMatchComments);
webComponentsMap.set(matchHeroSlimWidget.tag, DynamicMatchHeroSlim);
webComponentsMap.set(matchHeroWidget.tag, DynamicMatchHero);
webComponentsMap.set(matchLineupsFieldsWidget.tag, DynamicMatchStartupFormations);
webComponentsMap.set(matchLineupsWidget.tag, DynamicMatchLineups);
webComponentsMap.set(matchPredictedLineupsWidget.tag, DynamicMatchPredictedLineups);
webComponentsMap.set(matchStatisticsWidget.tag, DynamicMatchStatistics);
webComponentsMap.set(playerStatisticsWidget.tag, DynamicPlayerStatistics);
webComponentsMap.set(driverStatisticsWidget.tag, DynamicdriverStatistics);
// webComponentsMap.set(lgpResultsContainerWidget.tag, DynamicLgpResultsContainer);
webComponentsMap.set(lgpResultsWidget.tag, DynamicLgpResults);

defineWebComponents(webComponentsMap);

manageImagePlaceholders();

document.addEventListener('DOMContentLoaded', () => {
  ageCalc();
  resumeAthletePages();
  heroSlimSticky();
  hydrateTabsMenu();
  handleLgpTabs();
  activeTabScrollIntoView();
  clickFromHash();
});

window.addEventListener('player_page_statistic_loaded', () => {
  trackPageViews();
});

// To be enabled on Driver Page when statistics widget will be available

// window.addEventListener('driver_page_statistic_loaded', () => {
//   trackPageViews();
// });
